// extracted by mini-css-extract-plugin
export default {"base":"AaEVZ","title":"Nb9fO","inputMargin":"bsmZc","flexSection":"XQaKM","submit":"AuoEX"};